module.exports = __webpack_public_path__ + "img/Czech Republic.a638d373.gif";